import { toAbsoluteUrl } from "../../../../../../../_metronic/helpers";
import { defaultProfileImage } from "../../../../../../utils/constants";
import { handleImageErrorProfile } from "../../../../../../utils/UtilsFiles";

type Props = {
    conversation: any;
}

export const MessagesMemberInfo = ({ conversation }: Props) => {
    const avatarUrl = Array.isArray(conversation.avatar) ? conversation.avatar[0] : conversation.avatar;

    return (
        <div className="messages-info-member">
            <div className="degrate"></div>
            
            <div className="labels">
                <div className="d-flex flex-row justify-content-center align-items-center" style={{ gap: '10px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="1" viewBox="0 0 14 1" fill="none">
                        <path d="M0 0.25H13.5" stroke="white" stroke-width="0.5"/>
                    </svg>
                    <span className="new-member">MEMBER</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="1" viewBox="0 0 14 1" fill="none">
                        <path d="M0 0.25H13.5" stroke="white" stroke-width="0.5"/>
                    </svg>
                </div>
                <h4>{(conversation.isHost ?? conversation.is_host) ? "You" : (conversation.title || "User Info")}</h4>
            </div>

            <img src={avatarUrl ? (avatarUrl.startsWith('http') ? avatarUrl : toAbsoluteUrl(avatarUrl)) : toAbsoluteUrl(defaultProfileImage)} onError={handleImageErrorProfile}/>
        </div>
    )
}